module.exports = __webpack_public_path__ + "img/Djibouti.543ad0a9.svg";